import React, { useEffect, useState } from "react";
import Typography from '@mui/material/Typography';
import { Extension, FnAxios } from "utilities/utilities";
import { Box, Grid, Stack, Tooltip } from "@mui/material";
import { useLocation } from "react-router";
import "./Gallery.css";
import ImageListItemBar from '@mui/material/ImageListItemBar';
import { useNavigate } from "react-router";
import DialogPreview from "components/DialogPreview/DialogPreview";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles

import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import FilePopup from 'components/Input/UploadFile/components/PopUp/FilePopup';
const GalleryDetail = () => {
    const AxiosFn = FnAxios();
    const [arrGallery, setarrGallery] = useState([]);
    const [arrGalleryimg, setarrGalleryimg] = useState([]);
    const location = useLocation();
    const searchParams = location.search;
    const sID = new URLSearchParams(searchParams).get('sID');

    const [fileImage, setFileImage] = useState([]);

    const [IsopenPopUp, setIsopenPopUp] = useState<any>(false);
    const [isOpenPermission, setisOpenPermission] = useState<boolean>(false);
    const onGetData = () => {
        let param = { sID: sID };
        AxiosFn.Post(`GalleryImg/GetGalleryImg`, param, (result) => {
            setarrGallery(result.lstGalleryImg || []);
        })
    }

    const onGetDataimg = (nImageID) => {
        setisOpenPermission(true)
        let param = {
            sID: sID,
            nImageID: nImageID
        };
        AxiosFn.Post(`GalleryImg/GetGalleryImgPre`, param, (result) => {
            setarrGalleryimg(result.lstPreviewImg || []);
        })
    }
    useEffect(() => {
        onGetData();
    }, []);

    const OpenPopUp = (nImageID) => {

        let param = {
            sID: sID,
            nImageID: nImageID
        };
        AxiosFn.Post(`GalleryImg/GetGalleryImgPre`, param, (result) => {
            let lstDataType = [];
            (result.lstPreviewImg ?? []).forEach(f => {
                lstDataType.push(
                    f.ImageFile[0] ?? []
                )
            })
            setFileImage(lstDataType ?? []);
        })

        setIsopenPopUp(true);
    };

    return (
        <React.Fragment>
            {arrGallery.map((m, i) => {
                return (
                    <Grid container justifyContent={"center"} key={i}>
                        <Grid item container justifyContent={"center"} xs={12} md={12} >
                            <Typography variant="h3" fontWeight={500}>
                                {m.sDate}
                            </Typography>
                        </Grid>
                        <Grid item container justifyContent={"center"} xs={12} md={12} style={{ marginTop: 20 }} >
                            <Typography variant="h4" fontWeight={500}>
                                {m.sName}
                            </Typography>
                        </Grid>
                        {m.sHeadDescription !== null ? (
                            <Grid item container justifyContent={"center"} xs={12} md={12} style={{ marginTop: 20 }} >
                                <Typography variant="h5">
                                    {m.sHeadDescription}
                                </Typography>
                            </Grid>
                        ) : null}
                        {m.lstGalleryImg.length > 0 ? (
                            <Grid container spacing={{ xs: 2, md: 2 }} columns={{ xs: 4, sm: 8, md: 12 }} style={{ marginTop: 20 }}>
                                {m.lstGalleryImg.map((item, index) => {
                                    return (
                                        <Grid item xs={12} sm={4} md={4} key={index}>
                                            <Box
                                                className="box-Gallery"
                                            >
                                                <img
                                                    src={process.env.REACT_APP_API_URL + item.sImg}
                                                    alt={item.sImg}
                                                    style={{ width: "100%", height: "100%", minHeight: "auto", maxHeight: "37vw", objectFit: "cover", cursor: "pointer", }}
                                                    // style={{
                                                    //     width: '100%',
                                                    //     minWidth: "auto",
                                                    //     minHeight: "auto",
                                                    //     
                                                    //     cursor: "pointer",
                                                    // }}
                                                    onClick={() => OpenPopUp(item.nImageID)}
                                                />
                                                {(item.sNameForDisplay === null || item.sNameForDisplay === "") && (item.sDescription === null || item.sDescription === "") ? null : (
                                                    <ImageListItemBar style={{
                                                        width: '100%',
                                                        height: '20%',
                                                        // marginBottom: "2%"
                                                    }}
                                                        title={
                                                            <Stack
                                                                sx={{
                                                                    b: {
                                                                        "@media": {
                                                                            maxWidth: "500px",
                                                                            textOverflow: "ellipsis",
                                                                            whiteSpace: "nowrap",
                                                                            overflow: "hidden",
                                                                            cursor: "pointer",
                                                                        },
                                                                    },
                                                                }}
                                                            >
                                                                {/* picture name */}
                                                                <Tooltip title={item.sNameForDisplay}>
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: 16,
                                                                            fontWeight: "bolder",
                                                                            textTransform: "none",
                                                                        }}
                                                                        component="b"
                                                                    >
                                                                        {item.sNameForDisplay}
                                                                    </Typography>
                                                                </Tooltip>

                                                                {/* picture description */}
                                                                <Tooltip title={item.sDescription}>
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: 16,
                                                                            fontWeight: "lighter",
                                                                            textTransform: "none",
                                                                        }}
                                                                        component="b"
                                                                    >
                                                                        {item.sDescription}
                                                                    </Typography>
                                                                </Tooltip>
                                                            </Stack>
                                                        }
                                                    />
                                                )}
                                            </Box>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        ) :
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: "column",
                                    m: "5em 5em 8em 5em"
                                }}
                            >
                                <Typography sx={{ fontSize: "24px", color: "#aeb4b7" }}>
                                    ไม่พบข้อมูล
                                </Typography>
                            </Box>
                        }
                    </Grid>
                );
            })
            }

            {fileImage.map((m, i) => (
                <FilePopup
                    // file={fileImage}
                    file={m}
                    IsopenPopUp={IsopenPopUp}
                    ClosePopUp={() => { setIsopenPopUp(false) }}
                    sFile_ID={fileImage}
                    isGallery={true}
                    arrFile={fileImage}
                    id={fileImage}
                    setarrFile={setFileImage}
                    IsMultiple={true}
                    sPositionText="right"
                    cropRatio={16 / 9}
                    cropResize={true}
                    cropShape='retangle'
                    modeDisplay='gallery'
                    IsGalleryPage={true}
                />
            ))}
            {/* <FilePopup
                file={fileImage}
                IsopenPopUp={IsopenPopUp}
                ClosePopUp={() => { setIsopenPopUp(false) }}
                sFile_ID={fileImage}
                isGallery={true}
                arrFile={fileImage}
                id={fileImage}
                setarrFile={setFileImage}
                IsMultiple={true}
                sPositionText="right"
                cropRatio={16 / 9}
                cropResize={true}
                cropShape='retangle'
                modeDisplay='gallery'
            /> */}
        </React.Fragment>
    )
}

export default GalleryDetail;
